import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { Flex } from 'components/styled/containers/flex'
import { Body, H3 } from 'components/styled/typography'

const propTypes = {
  i18n: PropTypes.shape({
    withdraw: PropTypes.object.isRequired,
  }).isRequired,
}

export function WithdrawnThankYou({ i18n }) {
  return (
    <Flex alignItems="flex-start" flexDirection="column" mt="s40">
      <H3 mb="s16">{i18n.withdraw.thankYouTitle}</H3>
      <Body>{i18n.withdraw.thankYouText}</Body>
    </Flex>
  )
}

WithdrawnThankYou.propTypes = propTypes

export default connect(mapLanguageToComponentProps())(WithdrawnThankYou)
